import { actionGenerator } from '../../utils/redux/actionGenerator';

export const CHANGE_ADULT_COUNT = 'filters/change_adult_count' as const;

export const changeAdultCount = actionGenerator<typeof CHANGE_ADULT_COUNT, number>(CHANGE_ADULT_COUNT);

export type TChangeAdultCount = ReturnType<typeof changeAdultCount>;
